import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { AuthFormsService } from "src/app/shared/service/login-register-forms.service";
@Component({
  selector: "app-verify-email-sent",
  imports: [RouterModule],
  templateUrl: `./verify-email-sent.html`,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./verify-email-sent.css"],
})
export class VerifyEmailSentComponent implements OnInit {
  email: string = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authFormsService: AuthFormsService,
  ) {}

  ngOnInit(): void {
    this.email = this.route.snapshot.queryParamMap.get("email") ?? "";
  }

  goToLogin(): void {
    this.authFormsService.showLoginForm();
    this.router.navigate(["/login"]);
  }
}
